export const buildColumnOrderFromCookie = (cookie) => {
  const order = [];
  // eslint-disable-next-line no-restricted-syntax,no-unused-vars
  for (const group of cookie) {
    // eslint-disable-next-line no-restricted-syntax,no-unused-vars
    for (const child of group.order) {
      order.push(child.id);
    }
  }

  return order;
};
